import {
  savePhoneCode as savePhoneCodeInAPI,
  fetchPhoneCodes as fetchPhoneCodesFromAPI,
  fetchPhoneCodeById as fetchPhoneCodeByIdFromAPI,
  removePhoneCode,
  saveArticle as saveArticleInAPI,
  fetchArticles as fetchArticlesFromAPI,
  removeArticle,
  fetchArticleById as fetchArticleByIdFromAPI
} from '@/api/webcontent'

const fetchPhoneCodes = async ({ commit }, locale) => {
  let response = await fetchPhoneCodesFromAPI(locale)
  commit('SET_PHONE_CODES', response)
}

const startNewPhoneCode = ({ commit, state }) => {
  commit('SET_EMPTY_PHONE_CODE')
}

const setPhoneCode = ({ commit }, payload) => {
  commit('SET_PHONE_CODE_PROPERTY', payload)
}

const savePhoneCode = async ({ commit, state }, locale) => {
  await savePhoneCodeInAPI(state.newPhoneCode, locale).then((value) => {
    commit('SET_EMPTY_PHONE_CODE')
  })
}

const fetchPhoneCodeById = async ({ commit }, payload) => {
  let response = await fetchPhoneCodeByIdFromAPI(payload.id, payload.locale)
  commit('SET_PHONE_CODE', response)
}

const deletePhoneCode = async ({ commit }, payload) => {
  await removePhoneCode(payload.id, payload.locale)
}

const startNewArticle = ({ commit, state }) => {
  commit('SET_EMPTY_ARTICLE')
}

const setArticle = ({ commit }, payload) => {
  commit('SET_ARTICLE_PROPERTY', payload)
}

const saveArticle = async ({ commit, state }) => {
  await saveArticleInAPI(state.newArticle).then((value) => {
    commit('SET_EMPTY_ARTICLE')
  })
}

const setArticleLocale = ({ commit }, locale) => {
  commit('SET_ARTICLE_LOCALE', locale)
}

const setArticleCategory = ({ commit }, category) => {
  commit('SET_ARTICLE_CATEGORY', category)
}

const setNoIndex = ({ commit }, noIndex) => {
  commit('SET_NO_INDEX', noIndex)
}

const fetchArticles = async ({ commit }, locale) => {
  let response = await fetchArticlesFromAPI(locale)
  commit('SET_ARTICLES', response)
}

const deleteArticle = async ({ commit }, payload) => {
  await removeArticle(payload.id, payload.locale)
}

const fetchArticleById = async ({ commit }, payload) => {
  let response = await fetchArticleByIdFromAPI(payload.id, payload.locale)
  commit('SET_ARTICLE', response)
}

export default {
  fetchPhoneCodes,
  startNewPhoneCode,
  setPhoneCode,
  savePhoneCode,
  fetchPhoneCodeById,
  deletePhoneCode,
  startNewArticle,
  setArticle,
  saveArticle,
  setArticleLocale,
  setArticleCategory,
  setNoIndex,
  fetchArticles,
  deleteArticle,
  fetchArticleById
}



// WEBPACK FOOTER //
// ./src/store/modules/icg/actions.js